import React from "react";
import styles from "./FJResourceHeader.module.less";
import FJMainColorSwitch from "../../../common/component/FJMainColorSwitch";

function FJResourceHeader(props) {
  const {title, hasLine, hasSwitch, onSwitchChange, filterActive, onRender} = props;
  return (
    <div className={styles.header_box}>
      <span className={styles.header_text}>{title}</span>
      {hasLine ? <div className={styles.line}/> : null}
      {hasSwitch ? <div className={styles.switch}><FJMainColorSwitch active={filterActive} onChange={onSwitchChange}/></div> : null}
      {onRender && onRender()}
    </div>
  )
}

export default FJResourceHeader;